import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isDate } from '../utils';

export const maxDate = (maxDate: any): ValidatorFn => {
  const key = 'maxDate';

  if (!isDate(maxDate) && !(maxDate instanceof Function)) {
    throw Error('maxDate value must be or return a formatted date');
  }

  return (control: AbstractControl): ValidationErrors | null => {
    const value: any = control.value;
    if (!value) return null;

    const date: Date = new Date(value);
    if (!isDate(date)) return { [key]: true };
    if (maxDate instanceof Function) maxDate = maxDate();
    if (date > new Date(maxDate)) return { [key]: true };

    return null;
  };
};
